import dayjs from 'dayjs';

import { MIN_YEAR } from '.';

export const isYearInValidRange = (year: string) => {
  if (year.length !== 4) return false;
  if (isNaN(parseInt(year))) return false;

  const maxYear = dayjs().year();
  return Number(year) >= Number(MIN_YEAR) && Number(year) <= Number(maxYear);
};
